export default theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit / 2,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit / 2,
  },
  iconSmall: {
    fontSize: 12,
  },
});



// WEBPACK FOOTER //
// ./src/components/Buttons/IconButton.styles.js